import Queries from 'src/services/graphql/queries/index';
import { ChartInput } from 'src/services/graphql/Models';
import Chart from './classes/Chart';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';
import { observable } from 'mobx';
// import { processPotentialArray } from 'src/shared/utility';

// import commcaches from './commCache';
// import unitsensors from './unitsensor';
// import units from './unit';
// import sensortypes from './sensortype';
// import triggerableStats from './triggerablestat';
// import commCache from './commCache';

export class ChartStore extends DataStoreExtension<ChartInput, Chart> {
    listQueries: DocumentNode =  Queries.ListCharts;
    _createQueries = Queries.CreateChart;
    _updateQueries = Queries.UpdateChart;
    _deleteQueries = Queries.DeleteChart;
    
    @observable chartRenderProps: any;
    plainChartRenderProps: any;
    @observable override: any[];
    @observable stateUpdate: any;
    
    // @observable lastUpdate: any = Date.now();

    // get _chartRenderProps()  {
    //     const renderProps = {};
    //     const parsedCharts = this.getParsedItems;
    //     const commCacheItems = commCache.getParsedItems;
        
    //     const chartStates = this.stateUpdate;
    //     const overrides = this.override;
        
    //     processPotentialArray(
    //         parsedCharts , 
    //         (_charts) => processPotentialArray(
    //             _charts,
    //             chart => {
    //                 const typedId = chart.typedId;
    //                 const chartState = chartStates[typedId];
    //                 const override = overrides[typedId];

    //                 const recievedData = chart.getActualChartData({
    //                     commcaches, 
    //                     unitsensors, 
    //                     units,
    //                     sensortypes,
    //                     triggerableStats,
    //                     override,
    //                     commCacheItems,
    //                     chartState
    //                 });
    //                 renderProps[chart.typedId] = recievedData;            
    //             }
    //         )
    //     );
    //     return renderProps;    
    // }

    constructor() {
        super(false);

        this.stateUpdate = {};
        this.chartRenderProps = {};
        this.override = [];
        
        // const _callForceUpdate = () => { 
        //     const newUpdate = Date.now();
        //     if (newUpdate -  this.lastUpdate > 890) { 
        //         this.lastUpdate = newUpdate;
        //         setTimeout(() => this.updateRenderProps(), 890);
        //     }
        // };
        // const callForceUpdate = _callForceUpdate.bind(this);

        // observe(units, 'getParsedItems', callForceUpdate);
        // observe(unitsensors, 'getParsedItems', callForceUpdate);
        // observe(commcaches, 'getParsedItems', callForceUpdate);
        // observe(triggerableStats, 'getParsedItems', callForceUpdate);
        // observe(this.override, callForceUpdate);
        // observe(this.stateUpdate, callForceUpdate);
    }

    // @action
    // updateRenderProps() {
    //     const newChartRenderProps = this._chartRenderProps;
    //     this.plainChartRenderProps = newChartRenderProps;
    //     this.chartRenderProps  = newChartRenderProps;
    // }

    // @action
    // updateChartStates(changedState: any) {
    //     this.stateUpdate = {
    //         ...this.stateUpdate,
    //         [changedState.typedId]: changedState
    //     };
    // }

    // @action
    // addOverride(typedId: string, override: any) {
    //     this.override = {
    //         ...this.override,
    //         [typedId]: override
    //     };
    // }

    listVariables: any =  () => ({
        input:  {
            clientId: authStore.clientId,
            typedId: 'ch'
        }
    })

    toObject(from: ChartInput): Chart {
        return new Chart(from);
    }

    countError(obj: ChartInput) {
        let errors = [];
        const {
            name
        } = obj;

        if (!name || name.length < 2) {
            errors.push(new Error('SensorName is required'));
        }

        return errors;
    }

    parseDelete(obj: Chart) {
        return this.parseClientDelete(obj);
    }
}

export default new ChartStore();


// WEBPACK FOOTER //
// ./src/stores/application/chart.ts